<ft-sheet-tabs state-array="sheetTabs"><div class="sheet-tabs"><ul></ul></div></ft-sheet-tabs>

<div class="ft-section ft-config-section">
  <div class="ft-container">
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ContestDetails' | translate }}</div>
          <ft-language-selector-ng [languages]="data().contest?.languages?.item" [selectedLanguage]="model().language"
                                   (selectedLanguageChange)="model().language = $event" />
        </div>
      </div>
      <div class="ft-col-66">
        <!--CONTEST THEME PANEL-->
        <div class="ft-panel" [class.disabled]="themeLocked()" (click)="openThemeModal()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.platform.photoAdvocacy.ContestTheme' | translate }}</div>
            </div>
            <div class="ft-col-66">{{ data().contest?.theme }}</div>
          </div>
        </div>

        <!--AUTO INVITE SWITCH PANEL-->
        @if (data().contest?.theme == 'Standard') {
          <div class="ft-panel">
            <div class="ft-row" ft-modal-fields-editor (click)="editAutoInvite()">
              <div class="ft-col-33">
                <div class="ft-label" [innerHTML]="('flipto.account.sections.platform.photoAdvocacy.AutoInviteGuestsLong' | translate)"></div>
                <div class="ft-summary">{{ 'flipto.account.sections.platform.photoAdvocacy.AutoInviteSubText' | translate }}</div>
              </div>
              <div class="ft-col-66">{{ data().contest?.isAutoInvite | onOff }}</div>
            </div>
          </div>
        }

        <!--PRIVATE CONTEST SWITCH PANEL-->
        @if (data().contest?.theme != 'Standard') {
          <div class="ft-panel" [class.disabled]="isV2NotAdmin()">
            <div class="ft-row" ft-modal-fields-editor (click)="editPrivate()">
              <div class="ft-col-33">
                <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.PrivateContest' | translate }}</div>
              </div>
              <div class="ft-col-66">{{ data().contest?.isPrivate | onOff }}</div>
            </div>
          </div>
        }

        <!--CONTEST NAME PANEL-->
        <div class="ft-panel" ft-modal-fields-editor (click)="editContestName()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ContestName' | translate }}</div>
            </div>
            <div class="ft-col-66" [innerHTML]="displayHtml(model().language?.contestName, noneSetText)"></div>
          </div>
        </div>

        <!--CONTEST DATE RANGE PANEL-->
        <div class="ft-panel" (click)="openDateRangeModal()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.DateRange' | translate }}</div>
            </div>
            <div class="ft-col-66">
              {{ data().contest?.startDate | dateRange:data().contest?.endDate }}
              <div class="ft-summary">
                {{ 'flipto.account.sections.platform.photoAdvocacy.VotingEnds' | translate }} {{ data().contest?.votingEndDate | dateFormat:'MMM D, YYYY' }}
              </div>
            </div>
          </div>
        </div>

        <div class="ft-panel last">
          <div class="ft-row" (click)="openRankModal()">
            <div class="ft-col-33">
              <div class="ft-label" [innerHTML]="('flipto.account.sections.platform.photoAdvocacy.FinalistRankingDisplay' | translate)"></div>
            </div>
            <div class="ft-col-66">
              @if (data().contest?.isExactPlaceRanking) {
                <span>{{ 'flipto.account.sections.platform.photoAdvocacy.FinalistRankingType.Exact' | translate }}</span>
              }
              @if (!data().contest?.isExactPlaceRanking) {
                <span>{{ 'flipto.account.sections.platform.photoAdvocacy.FinalistRankingType.Braket' | translate }}</span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ShareMessage' | translate }}</div>
        </div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-modal-fields-editor (click)="editGuestMessage()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.Finalist' | translate }}</div>
            </div>
            <div class="ft-col-66" [innerHTML]="displayHtml(model().language?.guestMessage, noneSetText)"></div>
          </div>
        </div>
        <div class="ft-panel last" ft-modal-fields-editor (click)="editFollowerMessage()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.Friend' | translate }}</div>
            </div>
            <div class="ft-col-66" [innerHTML]="displayHtml(model().language?.followerMessage, noneSetText)"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.Goals' | translate }}</div>
        </div>
      </div>
      <div class="ft-col-66">
        <ft-finalist-incentives-ng [finalistIncentives]="data()?.contest?.finalistsIncentives"
                                   [propertyIncentives]="filteredIncentivesByTag()"
                                   (showModal)="openFinalistsGoalsModal()" />
        <ft-goals-panel-ng [goals]="data()?.contest?.goals?.item"
                           [culture]="model().language"
                           [propertyIncentives]="data()?.propertyIncentives"
                           [type]="2"
                           (showModal)="openGoalsModal()" />
      </div>
    </div>

    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ConsentTerms' | translate }}</div>
        </div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-modal-fields-editor (click)="editTerms()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.TermsAndConditionsForCampaigns' | translate }}</div>
            </div>
            <div class="ft-col-66">
              <div class="scroll-block ft-prevent-click" [innerHTML]="displayHtml(model().language?.terms, noneSetText)"></div>
            </div>
          </div>
        </div>
        <div class="ft-panel" ft-modal-fields-editor (click)="editReleaseTerms()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.PhotoReleaseForCampaigns' | translate }}</div>
            </div>
            <div class="ft-col-66">
              <div class="scroll-block ft-prevent-click" [innerHTML]="displayHtml(model().language?.releaseTerms, noneSetText)"></div>
            </div>
          </div>
        </div>
        <div class="ft-panel" ft-modal-fields-editor (click)="editSubmitConsent()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ConsentForStorySubmission' | translate }}</div>
            </div>
            <div class="ft-col-66">
              <div class="scroll-block ft-prevent-click" [innerHTML]="submitConsentHtml()"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">Phone consent</div>
        </div>
      </div>
      <div class="ft-col-66">
        <ft-toggle-editor title="Phone consent settings"
                          label="Status"
                          (save)="data().contest.isPhoneConsentFeatureEnabled = $event; save()"
                          [value]="phoneConsentEnabled">
          <!-- v1 details.html wrote [fluidLabel]="true", but AngularJS compiled that page — the
               bracket attr never bound, so master renders WITHOUT -fluid (label is 16.8px taller). -->
          <ft-edit-panel label="Phone consent settings">
            <div>{{ phoneConsentEnabled | onOff }}</div>
          </ft-edit-panel>
        </ft-toggle-editor>
        @if (phoneConsentEnabled || data().contest?.isPhoneConsentFeatureEnabled == '1') {
          <div class="ft-panel"
               ft-modal-fields-editor (click)="editPhoneConsent()">
            <div class="ft-row">
              <div class="ft-col-33">
                <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ConsentForPhoneNumber' | translate }}</div>
                <div class="ft-summary">Displayed only if the phone number field is turned on.</div>
              </div>
              <div class="ft-col-66">
                <div class="scroll-block ft-prevent-click" [innerHTML]="displayHtml(model().language?.phoneConsent, noneSetText)"></div>
              </div>
            </div>
          </div>
        }
        @if (phoneConsentEnabled || data().contest?.isPhoneConsentFeatureEnabled == '1') {
          <ft-select-editor title="Acceptance rule for phone number consent"
                            [value]="data().contest?.phoneConsentAcceptanceModeId"
                            [placeholder]="'Select person'"
                            (save)="data().contest.phoneConsentAcceptanceModeId = $event; save()"
                            [options]="model().phoneAcceptanceOptions"
                            [bindValue]="'value'"
                            [bindLabel]="'label'">
            <ft-edit-panel label="Acceptance rule for phone number consent">
              {{ phoneAcceptanceText(data().contest?.phoneConsentAcceptanceModeId) }}
            </ft-edit-panel>
          </ft-select-editor>
        }
        @if (phoneConsentEnabled || data().contest?.isPhoneConsentFeatureEnabled == '1') {
          <ft-select-editor title="Phone number for story submitters"
                            [value]="data().contest?.inviteePhoneDisplayModeId"
                            (save)="data().contest.inviteePhoneDisplayModeId = $event; save()"
                            [options]="model().phoneDisplayOptions"
                            [bindValue]="'value'"
                            [bindLabel]="'label'">
            <ft-edit-panel label="Phone number for story submitters">
              {{ phoneDisplayText(data().contest?.inviteePhoneDisplayModeId) }}
            </ft-edit-panel>
          </ft-select-editor>
        }
        @if (phoneConsentEnabled || data().contest?.isPhoneConsentFeatureEnabled == '1') {
          <ft-select-editor title="Phone number for friends"
                            [value]="data().contest?.friendPhoneDisplayModeId"
                            (save)="data().contest.friendPhoneDisplayModeId = $event; save()"
                            [options]="model().phoneDisplayOptions"
                            [bindValue]="'value'"
                            [bindLabel]="'label'">
            <ft-edit-panel label="Phone number for friends">
              {{ phoneDisplayText(data().contest?.friendPhoneDisplayModeId) }}
            </ft-edit-panel>
          </ft-select-editor>
        }
      </div>
    </div>

    @if (data().contest?.poststayEmailImageIsActive || data().contest?.prearrivalEmailImageIsActive) {
      <div class="ft-row">
        <div class="ft-col-33">
          <div class="ft-section-header">
            <div class="ft-label">{{ 'flipto.account.EmailBanners' | translate | capitalize }}</div>
          </div>
        </div>
        <div class="ft-col-66">
          <div class="ft-multi-panel last">
            <div class="ft-panel" (click)="openImageLibraryModal()">
              <div class="ft-row">
                <div class="ft-col-33">
                  <div class="ft-label">{{ 'flipto.account.BannerImage' | translate }}</div>
                </div>
                <div class="ft-col-66">
                  <div class="thumbnail-image" [ftBackgroundImage]="data().contest?.backgroundImage || model().defaultBackgroundImageUrl">
                    <span class="placeholder" [hidden]="(data().contest?.backgroundImage || model().defaultBackgroundImageUrl)">{{ 'flipto.account.AddAnImage' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
            @if (data().contest?.prearrivalEmailImageIsActive) {
              <!-- v1 ft-targets-modal="modals.emailImages.prearrival.preview" +
                   ft-disable-while-task-pending="update-email-images" (disabled attr + pointer-events:none). -->
              <div class="ft-panel" [class]="'ft-panel ' + (data().contest?.prearrivalEmailImageIsActive || '')"
                   [attr.disabled]="isEmailImagesUpdating() ? 'disabled' : null"
                   [style.pointer-events]="isEmailImagesUpdating() ? 'none' : null"
                   (click)="prearrivalPreviewOpen.set(true)">
                <div class="ft-row">
                  <div class="ft-col-33">
                    <div class="ft-label">{{ 'flipto.account.PrearrivalBannerPreview' | translate }}</div>
                  </div>
                  <div class="ft-col-66">
                    @if (!data().contest?.prearrivalEmailImages?.item?.length) {
                      <span class="placeholder">{{ 'flipto.account.platform.ClickToPreview' | translate }}</span>
                    }
                    <ft-email-images-preview-ng [images]="data().contest?.prearrivalEmailImages?.item" emailImageType="prearrival"
                                                [(open)]="prearrivalPreviewOpen" (refresh)="refreshPrearrivalImage($event)" />
                  </div>
                </div>
              </div>
            }
            @if (data().contest?.poststayEmailImageIsActive) {
              <!-- v1 ft-targets-modal="modals.emailImages.poststay.preview" + ft-disable-while-task-pending. -->
              <div class="ft-panel" [class]="'ft-panel ' + (data().contest?.poststayEmailImageIsActive || '')"
                   [attr.disabled]="isEmailImagesUpdating() ? 'disabled' : null"
                   [style.pointer-events]="isEmailImagesUpdating() ? 'none' : null"
                   (click)="poststayPreviewOpen.set(true)">
                <div class="ft-row">
                  <div class="ft-col-33">
                    <div class="ft-label">{{ 'flipto.account.PoststayBannerPreview' | translate }}</div>
                  </div>
                  <div class="ft-col-66">
                    @if (!data().contest?.poststayEmailImages?.item?.length) {
                      <span class="placeholder">{{ 'flipto.account.platform.ClickToPreview' | translate }}</span>
                    }
                    <ft-email-images-preview-ng [images]="data().contest?.poststayEmailImages?.item" emailImageType="poststay"
                                                [(open)]="poststayPreviewOpen" (refresh)="refreshPoststayImage($event)" />
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ContestStyling' | translate }}</div>
        </div>
      </div>
      <div class="ft-col-66">
        <!--CSS PANEL-->
        <div class="ft-panel last">
          <div class="ft-row" ft-modal-fields-editor (click)="editCss()">
            <div class="ft-col-33">
              <div class="ft-label" [innerHTML]="('flipto.account.CSS' | translate)"></div>
              <div class="ft-summary" [innerHTML]="('flipto.account.sections.platform.photoAdvocacy.ContestStylingSummary' | translate)"></div>
            </div>
            <div class="ft-col-66">
              <div class="css-text" [innerHTML]="displayHtml(data().contest?.contestCss, clickToEditText)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ftModal phase 2: native field-editor modal shell (CDK overlay → stacks above the
     CDK contest sheet, fixing the bridged-ftModal occlusion). Bool editors only so far;
     other field types still use the bridged ftModal until natively ported. -->
<ft-field-editor-modal [config]="fieldEditorConfig()" (closed)="fieldEditorConfig.set(null)" />

<!-- ftModal phase 2 / WS3: the "Banner image" modal, native. Replaces the bridged
     <ft-modal id="contest-details.imageLibraryModal" ft-snapshot="data.contest,model.isUseDefaultImage"
     on-done="updateBackgroundImage"> compile: native ft-modal-overlay + ft-modal-chrome-ng hosting
     the "use default image" ft-switch + the native ft-image-library-ng (image-type 3). Done →
     updateBackgroundImage() (direct save API, no pending panel); X/Cancel → revert the snapshotted
     backgroundImage + isUseDefaultImage. -->
<ft-modal-overlay [open]="bannerModalOpen()">
  @if (bannerModalOpen()) {
    <ft-modal-chrome-ng
      [headerText]="'flipto.account.BannerImage' | translate"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onBannerDone()"
      (cancel)="onBannerCancel()"
    >
      <div class="modal-panel">
        {{ 'flipto.account.UseDefaultImage' | translate }}
        <!-- Inline .ft-switch DOM (NOT the <ft-switch> FtSwitchComponent element) — its selector
             collides with the AngularJS ftSwitch E-directive, which throws "Unknown provider:
             ContestContainer" when AngularJS $compiles this CDK overlay at <body> outside the
             container scope. The DOM is byte-identical to FtSwitchComponent's template. -->
        <div class="ft-switch">
          <input
            class="ft-switch-toggle"
            type="checkbox"
            [id]="bannerSwitchUid"
            [checked]="model().isUseDefaultImage"
            (change)="onBannerSwitchToggle($event)"
          />
          <label [attr.for]="bannerSwitchUid"></label>
        </div>
      </div>
      @if (!model().isUseDefaultImage) {
        <ft-image-library-ng
          [images]="data().propertyImages"
          [propertyId]="model().propertyId"
          [imageType]="3"
          view="list"
          (imageSelected)="updateImage($event)"
         />
      }
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the "Finalist ranking display" modal, native. Replaces the bridged
     accountapp.photocontest.details.rank-system-type compile (a 2-option .ft-dropdown toggling
     data.contest.isExactPlaceRanking). The dropdown open/close is a local rankOpen flag (NOT the
     AngularJS ft-click-class). Done → save(); X/Cancel → revert isExactPlaceRanking. -->
<ft-modal-overlay [open]="rankModalOpen()">
  @if (rankModalOpen()) {
    <ft-modal-chrome-ng
      [headerText]="'flipto.account.sections.platform.photoAdvocacy.FinalistRankingDisplay' | translate"
      [headerDescription]="'flipto.account.sections.platform.photoAdvocacy.FinalistRankingDisplaySummary' | translate"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onRankDone()"
      (cancel)="onRankCancel()"
    >
      <div class="modal-panel">
        <div class="ft-dropdown" [class.active]="rankOpen()">
          <a class="ft-dropdown-toggle" (click)="rankOpen.set(!rankOpen())">
            @if (data().contest?.isExactPlaceRanking) {
              <span>{{ 'flipto.account.sections.platform.photoAdvocacy.FinalistRankingType.Exact' | translate }}</span>
            }
            @if (!data().contest?.isExactPlaceRanking) {
              <span>{{ 'flipto.account.sections.platform.photoAdvocacy.FinalistRankingType.Braket' | translate }}</span>
            }
            <i class="ft-icn-caret-down"></i>
          </a>
          <ul class="ft-dropdown-menu">
            <li (click)="setRank(true)"><a>{{ 'flipto.account.sections.platform.photoAdvocacy.FinalistRankingType.Exact' | translate }}</a></li>
            <li (click)="setRank(false)"><a>{{ 'flipto.account.sections.platform.photoAdvocacy.FinalistRankingType.Braket' | translate }}</a></li>
          </ul>
        </div>
      </div>
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the contest "Theme" modal, native. Replaces the bridged
     contest-details.themeModal compile (a grid of theme cards). DIRECT-save: clicking a card
     calls updateTheme(id) (photo-contest PUT) then closes (v1 ng-click="updateTheme(id); done()").
     footer-visible=false (no Save/cancel footer — only the X); size lg; the contest-theme-modal
     class drives the grid layout (modalClass passthrough). Gate-coverable only on a 0-submission
     contest (themeLocked = totalSubmissions > 0) — the gate fixture forces totalSubmissions=0. -->
<ft-modal-overlay [open]="themeModalOpen()">
  @if (themeModalOpen()) {
    <ft-modal-chrome-ng
      modalClass="contest-theme-modal"
      [headerText]="'flipto.account.platform.photoAdvocacy.ContestTheme' | translate"
      [headerDescription]="'flipto.account.platform.photoAdvocacy.ContestThemeDescription' | translate"
      size="lg"
      [doneVisible]="false"
      [cancelVisible]="true"
      [footerVisible]="false"
      (cancel)="themeModalOpen.set(false)"
    >
      @for (theme of data().contest?.themes; track theme) {
        <a
          class="contest-theme"
          [class]="'contestTheme' + theme.name"
          (click)="selectTheme(theme)"
        >
          <div class="contest-theme-details">
            <div class="contest-theme-title">{{ theme.title }}</div>
            <div class="contest-theme-description">{{ theme.description }}</div>
          </div>
        </a>
      }
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the contest "Date range" modal, native. Replaces the bridged
     editDateRangeModal compile. Hosts the native ft-date-range-picker-ng (wraps the SAME jQuery
     daterangepicker plugin → identical calendar). DIRECT-save: Done → saveContestDates() (PUT);
     X/Cancel → revert data.contest.startDate/endDate to the open-time moment clones. -->
<ft-modal-overlay [open]="dateRangeModalOpen()">
  @if (dateRangeModalOpen()) {
    <ft-modal-chrome-ng
      [headerText]="'flipto.account.sections.platform.photoAdvocacy.DateRange' | translate"
      [headerDescription]="'flipto.account.sections.platform.photoAdvocacy.DateRangeDescription' | translate"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onDateRangeDone()"
      (cancel)="onDateRangeCancel()"
    >
      <div class="modal-panel">
        <ft-date-range-picker-ng [startDate]="data().contest?.startDate"
          [endDate]="data().contest?.endDate"
          (startDateChange)="data().contest.startDate = $event"
          (endDateChange)="data().contest.endDate = $event"
         />
      </div>
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the contest "Goals for finalist" (finalistsGoals) modal, native.
     Replaces the bridged finalistsGoalsModal compile (the ft-finalist-goal-selector + ft-runnerups
     AngularJS sub-directives are now native ft-finalist-goal-selector-ng / ft-runnerups-ng). The
     5 conditional winner/runnerup/participant panels + the add/delete rows + the footer adds are
     reproduced verbatim. DIRECT-save: Done -> saveFinalistIncentives() (unchanged, photo-contest
     PUT); X/Cancel -> revert the snapshotted data.contest.finalistsIncentives. -->
<ft-modal-overlay [open]="finalistsModalOpen()">
  @if (finalistsModalOpen()) {
    <ft-modal-chrome-ng
      [headerText]="finalistsModalHeader"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onFinalistsDone()"
      (cancel)="onFinalistsCancel()"
    >
      @if (!(fi()?.firstWinnerIncentive || fi()?.secondWinnerIncentive || fi()?.thirdWinnerIncentive)) {
        <div class="modal-panel">
          <span>{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
        </div>
      }
      @if (fi()?.firstWinnerIncentive) {
        <div class="modal-panel">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.FirstPlace' | translate }}</div>
          <ft-finalist-goal-selector-ng [incentive]="fi().firstWinnerIncentive" [propertyIncentives]="filteredIncentivesByTag()" />
        </div>
      }
      @if (fi()?.secondWinnerIncentive) {
        <div class="modal-panel">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.SecondPlace' | translate }}</div>
          <ft-finalist-goal-selector-ng [incentive]="fi().secondWinnerIncentive" [propertyIncentives]="filteredIncentivesByTag()" />
          <div class="modal-panel-actions">
            @if (!fi()?.thirdWinnerIncentive) {
              <a class="action btn-delete-item" (click)="removeFinalistSlot('secondWinnerIncentive')"></a>
            }
          </div>
        </div>
      }
      @if (fi()?.thirdWinnerIncentive) {
        <div class="modal-panel">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ThirdPlace' | translate }}</div>
          <ft-finalist-goal-selector-ng [incentive]="fi().thirdWinnerIncentive" [propertyIncentives]="filteredIncentivesByTag()" />
          <div class="modal-panel-actions">
            <a class="action btn-delete-item" (click)="removeFinalistSlot('thirdWinnerIncentive')"></a>
          </div>
        </div>
      }
      @if (fi()?.runnerUpsIncentive) {
        <div class="modal-panel">
          <div class="ft-label">
            <ft-runnerups-ng [incentive]="fi().runnerUpsIncentive" />
            {{ 'flipto.account.sections.platform.photoAdvocacy.RunnerUps' | translate }}
          </div>
          <ft-finalist-goal-selector-ng [incentive]="fi().runnerUpsIncentive" [propertyIncentives]="filteredIncentivesByTag()" />
          <div class="modal-panel-actions">
            <a class="action btn-delete-item" (click)="removeFinalistSlot('runnerUpsIncentive')"></a>
          </div>
        </div>
      }
      @if (fi()?.finalistIncentive) {
        <div class="modal-panel">
          <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.Participant' | translate }}</div>
          <ft-finalist-goal-selector-ng [incentive]="fi().finalistIncentive" [propertyIncentives]="filteredIncentivesByTag()" />
          <div class="modal-panel-actions">
            <a class="action btn-delete-item" (click)="removeFinalistSlot('finalistIncentive')"></a>
          </div>
        </div>
      }
      <div class="modal-footer-align">
        @if (!fi()?.firstWinnerIncentive) {
          <a class="ft-btn ft-btn-outline-light btn-add-panel" (click)="addFinalistSlot('firstWinnerIncentive')">
            <i class="ft-icn-plus"></i> {{ 'flipto.account.sections.platform.photoAdvocacy.FirstPlace' | translate }}
          </a>
        }
        @if (!fi()?.secondWinnerIncentive && fi()?.firstWinnerIncentive) {
          <a class="ft-btn ft-btn-outline-light btn-add-panel" (click)="addFinalistSlot('secondWinnerIncentive')">
            <i class="ft-icn-plus"></i> {{ 'flipto.account.sections.platform.photoAdvocacy.SecondPlace' | translate }}
          </a>
        }
        @if (!fi()?.thirdWinnerIncentive && fi()?.secondWinnerIncentive) {
          <a class="ft-btn ft-btn-outline-light btn-add-panel" (click)="addFinalistSlot('thirdWinnerIncentive')">
            <i class="ft-icn-plus"></i> {{ 'flipto.account.sections.platform.photoAdvocacy.ThirdPlace' | translate }}
          </a>
        }
        @if (!fi()?.runnerUpsIncentive) {
          <a class="ft-btn ft-btn-outline-light btn-add-panel" (click)="addRunnerUps()">
            <i class="ft-icn-plus"></i> {{ 'flipto.account.sections.platform.photoAdvocacy.RunnerUps' | translate }}
          </a>
        }
        @if (!fi()?.finalistIncentive) {
          <a class="ft-btn ft-btn-outline-light btn-add-panel" (click)="addFinalistSlot('finalistIncentive')">
            <i class="ft-icn-plus"></i> {{ 'flipto.account.sections.platform.photoAdvocacy.Participant' | translate }}
          </a>
        }
      </div>
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the contest "Goals for friends" (contestGoals) modal, native.
     Replaces the bridged contestGoalsModal compile (the ft-edit-goals + ft-goal-selector +
     ft-incentive-selector AngularJS sub-directives are now native ft-edit-goals-ng /
     ft-goal-selector-ng / ft-incentive-selector-ng). v1 (goalsPanel.html) had NO ft-snapshot
     → X/Cancel just closes (no revert; editGoalsModel.updateGoals reference the live goal
     objects, mutated in place — preserve-behaviour). DIRECT-save: Done -> saveGoalsFromModal()
     (unchanged: split markedForRemoval → deleteGoals ids, then serialize + PUT). -->
<ft-modal-overlay [open]="goalsModalOpen()">
  @if (goalsModalOpen()) {
    <ft-modal-chrome-ng
      [headerText]="'flipto.components.goals.GoalsForFriends' | translate"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onGoalsDone()"
      (cancel)="onGoalsCancel()"
    >
      <ft-edit-goals-ng [goals]="editGoalsModel()"
        [incentives]="goalsIncentivesByTag()"
        [culture]="model().language"
        [type]="2"
       />
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>
